import React, { Component } from "react";
import DevFeisCostEstimateForm from "./DevFeisCostEstimateForm";
import SmallModal from "../../../../hoc/UI/SmallModal/SmallModal";
import { Button } from "rsuite";

class DevFeisCostEstimate extends Component {
  state = {
    proj_dev_feis_cost_estimate_id: null
  };

  componentDidMount() {
    this.props.devFeisCostEstimate.fetch();
  }
  render() {
    let smallModal = null;
    if (this.props.showSmallModal) {
      smallModal = (
        <SmallModal>
          <DevFeisCostEstimateForm
            toggleSmallModalHandler={this.props.toggleSmallModalHandler}
            currentDevFeisCostEstimate={
              this.state.proj_dev_feis_cost_estimate_id === null
                ? null
                : this.props.devFeisCostEstimate.devFeisCostEstimate.find(
                    devFeisCostEstimate =>
                      devFeisCostEstimate.proj_dev_feis_cost_estimate_id ===
                      this.state.proj_dev_feis_cost_estimate_id
                  )
            }
            update={this.props.devFeisCostEstimate.update}
            add={this.props.devFeisCostEstimate.add}
            projectID={this.props.currentProjectID}
            disabled={this.props.disabled}
          />
        </SmallModal>
      );
    }
    return (
      <div className="container-fluid">
        {smallModal}
        <div style={{ textAlign: "right" }}>
          <Button
            className="my-2"
            color="blue"
            onClick={() => {
              this.setState({ proj_dev_feis_cost_estimate_id: null });
              this.props.toggleSmallModalHandler();
            }}
          >
            Create New Dev FEIS Cost Estimate
          </Button>
        </div>

        <table className="table">
          <thead>
            <tr>
              <th>annual inflation adjustment</th>
              <th>capital cost</th>
              <th>capital cost breakdown</th>
              {this.props.disabled ? null : <th>Action</th>}
              {/*<th>estimated cost type</th>*/}
              {/*<th>financial cost</th>*/}
              {/*<th>financial cost breakdown</th>*/}
              {/*<th>notes</th>*/}
              {/*<th>other cost</th>*/}
              {/*<th>other cost breakdown</th>*/}
              {/*<th>risk assessment</th>*/}
              {/*<th>risk total value</th>*/}
            </tr>
          </thead>
          <tbody>
            {this.props.devFeisCostEstimate.devFeisCostEstimate.map(item => (
              <tr
                key={item.proj_dev_feis_cost_estimate_id}
                onClick={e => {
                  if (e.target.type !== "button") {
                    this.setState({
                      proj_dev_feis_cost_estimate_id:
                        item.proj_dev_feis_cost_estimate_id
                    });
                    this.props.toggleSmallModalHandler();
                  }
                }}
              >
                <td>{item.annual_inflation_adjustment}</td>
                <td>{item.capital_cost}</td>
                <td>{item.capital_cost_breakdown}</td>
                {/*<td>{item.estimated_cost_type}</td>*/}
                {/*<td>{item.financial_cost}</td>*/}
                {/*<td>{item.financial_cost_breakdown}</td>*/}
                {/*<td>{item.notes}</td>*/}
                {/*<td>{item.other_cost}</td>*/}
                {/*<td>{item.other_cost_breakdown}</td>*/}
                {/*<td>{item.risk_assessment}</td>*/}
                {/*<td>{item.risk_total_value}</td>*/}
                {this.props.disabled ? null : (
                  <td>
                    <Button
                      color="blue"
                      type="button"
                      onClick={() => {
                        this.setState({
                          proj_dev_feis_cost_estimate_id:
                            item.proj_dev_feis_cost_estimate_id
                        });
                        this.props.toggleSmallModalHandler();
                      }}
                    >
                      Edit
                    </Button>{" "}
                    <Button
                      type="button"
                      onClick={() =>
                        this.props.devFeisCostEstimate.delete(
                          item.proj_dev_feis_cost_estimate_id,
                          this.props.currentProjectID
                        )
                      }
                      color="red"
                    >
                      Delete
                    </Button>
                  </td>
                )}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }
}

export default DevFeisCostEstimate;
